module.exports = __webpack_public_path__ + "static/media/vacuum.e5b28926.svg";